<template>
  <v-card class="mt-2" v-if="eligibilities && eligibilities != {}">
    <v-toolbar flat class="transparent">
      <div>
        <div class="headline">Eligibilities Breakdown</div>
        <span class="grey--text">{{ total.toLocaleString() }} eligibilities in total</span>
      </div>

      <v-spacer />

      <can I="prioritize" a="Eligibility">
        <v-tooltip bottom>
          <v-btn
            small
            flat
            fab
            @click="prioritize"
            color="yellow darken-2"
            :loading="prioritizing"
            slot="activator"
          >
            <v-icon>mdi-star</v-icon>
          </v-btn>
          <span>Prioritize this opportunity for processing</span>
        </v-tooltip>
      </can>
      <can I="reset" a="Eligibility">
        <v-tooltip bottom>
          <v-btn small flat fab @click="clear" color="red" slot="activator">
            <v-icon>mdi-nuke</v-icon>
          </v-btn>
          <span>Clear all eligibilities for this opportunity</span>
        </v-tooltip>
      </can>
      <v-btn v-if="!eligibilities.ineligible" small :loading="loading" @click="refresh">Load</v-btn>
      <v-btn v-else small flat fab :loading="loading" @click="refresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <div class="text-xs-center">
        <v-tooltip bottom v-if="eligibilities.eligible">
          <span :style="progressWidthStyle(percentage(eligibilities.eligible))" slot="activator">
            <v-progress-linear color="success" value="100" />
          </span>
          <span>{{ eligibilities.eligible }} Eligible</span>
        </v-tooltip>
        <v-tooltip bottom v-if="eligibilities.indeterminate">
          <span
            :style="progressWidthStyle(percentage(eligibilities.indeterminate))"
            slot="activator"
          >
            <v-progress-linear color="grey" value="100" />
          </span>
          <span>{{ eligibilities.indeterminate }} Indeterminate</span>
        </v-tooltip>
        <v-tooltip bottom v-if="eligibilities.ineligible">
          <span :style="progressWidthStyle(percentage(eligibilities.ineligible))" slot="activator">
            <v-progress-linear color="error" value="100" />
          </span>
          <span>{{ eligibilities.ineligible }} Ineligible</span>
        </v-tooltip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      prioritizing: false,
      eligibilities: {},
    }
  },
  computed: {
    total() {
      return Object.keys(this.eligibilities).reduce(
        (acc, cur) => (acc += this.eligibilities[cur]),
        0
      )
    },
  },
  methods: {
    progressWidthStyle(width) {
      return { display: 'inline-block', width: `${width * 0.95}%` }
    },
    percentage(value) {
      return (value / this.total) * 100
    },
    refresh() {
      this.loading = true
      Vue.$http
        .get(`admin/tools/eligibilities?opportunity=${this.$route.params.id}`)
        .then(({ data }) => (this.eligibilities = data))
        .finally(() => (this.loading = false))
    },
    clear() {
      Vue.$http
        .delete(`admin/tools/eligibilities?opportunity=${this.$route.params.id}`)
        .then(this.refresh)
    },
    prioritize() {
      this.prioritizing = true
      Vue.$http
        .post(`admin/opportunities/${this.$route.params.id}/prioritize`)
        .then(({ data }) => {
          this.$store.dispatch('snackbarShow', 'Opportunity prioritized successfully!')
        })
        .catch(error => {
          this.$store.dispatch('snackbarShow', 'Failed to prioritize opportunity')
          console.error('Prioritize error:', error)
        })
        .finally(() => {
          this.prioritizing = false
        })
    },
  },
}
</script>
